import styles from "pages/produkt/product.page.module.scss";
import Link from "next/link";
import Image from "grandus-lib/components-atomic/image/Image";
import get from "lodash/get";
import filter from "lodash/filter";

const ProductLabelsPhoto = ({ product, productCard = false }) => {
  const photoLabels = filter(get(product, 'labels'), label => label?.photo);

  return (
    <div
      className={`${
        productCard ? styles.productCardLabels : styles.productLabels
      }`}
    >
      {photoLabels.slice(0, 3).map((label, index) => (
        <Link href={`/produkt/${product.urlTitle}`} key={`photo-label-${index}`}>
          <a className={`${styles?.productPadding}`}>
            <Image
              photo={label?.photo}
              size={productCard ? "40" : "60"}
              alt=""
              type={"png"}
            />
          </a>
        </Link>
      ))}
    </div>
  );
};

export default ProductLabelsPhoto;
